import {
  IPlatformPrivateEvent,
  PlatformLifecycleEvent,
  PlatformPrivateEvent,
  // --
  IPlatformAppEvent,
  PlatformAppEvent,
  PlatformAppEventEmitter,
} from '@wix/public-editor-platform-events';

/**
 * The events bridge between platform events (private) and app events
 */
export class ApplicationEventsBridge {
  constructor(private platformAppEvents: PlatformAppEventEmitter) {}

  /**
   * Notify by event from Worker Manager (platform infrastructure)
   */
  public notify(event: IPlatformPrivateEvent) {
    switch (event.type) {
      case PlatformLifecycleEvent.EditorReady:
        this.platformAppEvents.notify({
          ...event,
          // @ts-expect-error TODO: fix me
          type: PlatformAppEvent.EditorReady,
        });
        break;
      case PlatformPrivateEvent.HostEvent:
        this.platformAppEvents.notify({
          ...event,
          type: PlatformAppEvent.HostEvent,
        });
        break;
    }
  }

  /**
   * Subscribe to Worker (Application) event
   */
  public subscribe(cb: (event: IPlatformAppEvent) => void) {
    this.platformAppEvents.subscribe((event) => {
      cb(event);
    });
  }
}
